import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import { Container, Col, Row, ButtonGroup, Button } from 'react-bootstrap'
import { notification } from 'antd'
import { NCM, CEST, CFOP, ICMS, SelectICMS, IPI, PIS } from '@taxes'
import { setNcm, setCest, setCfop, setIcms, setPis, setIpi } from '@taxes/actions'
import ImportProductFromNFeXML from "../../../../views/AppViews/Products/imports/NFeXML"
import ImportProductFromCSV from "../../../../views/AppViews/Products/imports/ProductCSV"
import {
  setBaseProductName,
  setBaseProductBarcode,
  setBaseProductPrice,
  setBaseProductCost,
  setBaseProductInternalCode,
  setUnit,
  setCategorie
} from './actions'

//import translate from '../product/product-base/translate.json'
//const productLabels = translate[navigator.language];
import ProductModel from '../../../../models/base/product'
import CreateProductHelper from '../../../tutorials/create_product'

const product = new ProductModel()

import { getBranchOwner, api, get } from '@config'
import { setLoading } from '@inspinia-react/actions'

import ProductStock from './stock'
import ProductBase from './product-base'
import { mapTest } from '../map.test';
import { checkIfBranchExists } from '../../../../utils';
import Modal from '../../../../_components/Modal';
import ReCAPTCHA from "react-google-recaptcha"


function BaseProduct(props) {
  checkIfBranchExists()

  const branch = getBranchOwner()

  const [isFiscal, setIFiscal] = React.useState(false)
  const [showModal, setShowModal] = React.useState(false)
  const [passedCaptcha, setPassedCaptcha] = React.useState(true)
  const [visualCode, setVisualCode] = React.useState(0)
  

  const PRODUCT_FISCAL_COMPONENETS = isFiscal
    ? <Col>
      <div className="py-2">
        <ProductStock />
      </div>
      <div className="py-2">
        <NCM />
      </div>
      <div className="py-2">
        <CFOP />
      </div>
      <div className="py-2">
        <SelectICMS />
      </div>
      <div className="py-2">
        <CEST />
      </div>
      <div className="py-2">
        <IPI as="select" />
      </div>
      {branch.crt === 2 || branch.crt === 1 ? "" : <div>
        <div className="py-2">
          <PIS />
        </div>
      </div>}
    </Col>
    : <div />

  function cancel() {
    window.history.back()
  }



  function getProductCode() {
    const url = `${api.products.maxCode}?branch_owner=${branch.id}`;
    function payload(response) {
      if(response.max_code === null){
        props.setBaseProductInternalCode(1)
        return
      }
      
      let maxCode = Number(response.max_code)+1
      setVisualCode(maxCode)
      props.setBaseProductInternalCode(maxCode)
    }
    get(url, payload);
  }

  function save() {
    props.setLoading(true)
    product.initFromProps(props)
    const success = product => {
      notification.open({
        type: "success",
        message: "Produto cadastrado",
        description: <p>
          Produto cadastrado com sucesso. {props.initialStock ? <span>Com estoque inicial de {props.initialStock}</span> : null}
        </p>

      })
      setTimeout(() => {
        window.location.href = `/products`
      }, 500)
    }
    const errorPayload = errors => {
      props.setLoading(false)
    }
    product.save(success, errorPayload)
  }

  React.useEffect(() => {
    setTimeout(() => {
      getProductCode()
    }, 300);
    setIFiscal(Boolean(branch.is_fiscal))
  }, [])

  return <Container className="py-2 mb-5">
    <div class="d-flex flex-row-reverse">
      <CreateProductHelper />
    </div>
    <h2 className='text-center'>Cadastrar Produto Nº{visualCode}</h2>
    <Row>
      <Col>

        <Button onClick={() => setShowModal(true)}>
          Importar via XML ou CSV
        </Button>
        <Modal title="Importar produto via XML ou CSV" show={showModal} onHide={() => { setPassedCaptcha(false), setShowModal(false) }}>
          <div className='d-flex justify-content-center'>
              <div className=''>
                <ReCAPTCHA
                  hidden={passedCaptcha}
                  sitekey="6LdfmIUlAAAAAJUK2xhCmFq0YwpvelFOLAXSFuHw"
                  onChange={() => { setTimeout(()=>{setPassedCaptcha(true)},500)}}
                />
              </div>
              {passedCaptcha? <Row className='justify-content-between'>
                <ImportProductFromNFeXML closeFirstModal={() => { setShowModal(false) }} />
              <div style={{ marginInline: 10 }} />
              <ImportProductFromCSV closeFirstModal={() => { setShowModal(false) }} />
              </Row>:
              ''}
          </div>
        </Modal>
        <ProductBase />
        {!isFiscal ? <div className="py-2">
          <ProductStock />
        </div> : <div />}
      </Col>
      {PRODUCT_FISCAL_COMPONENETS}
    </Row>
    <ButtonGroup className="w-100 mt-2">
      <Button id={mapTest.createProduct.cancelButton} onClick={cancel} variant="danger" className="w-50">
        Cancelar
      </Button>
      &nbsp;&nbsp;
      <Button id={mapTest.createProduct.createButton} onClick={save} className="w-50">
        Salvar
      </Button>
    </ButtonGroup>
  </Container>
}

const mapStateToProps = state => ({
  barcode: state.baseProductBarcode,
  name: state.baseProductName,
  code: state.baseProductInternalCode,
  cost: state.baseProductCost,
  price: state.baseProductPrice,
  unit: state.unit,
  initialStock: state.initialStock,
  category: state.category,

  ncm: state.ncm,
  cest: state.cest,
  cfop: state.cfop,
  icms: state.icms,

  pis: state.pis,
  ipi: state.ipi
});

const mapDispatchToProps = disptch => bindActionCreators({
  setLoading,
  setBaseProductName,
  setBaseProductBarcode,
  setBaseProductPrice,
  setBaseProductCost,
  setBaseProductInternalCode,
  setUnit,
  setCategorie,

  setNcm, setCest, setCfop, setIcms, setPis, setIpi
}, disptch);

export default connect(mapStateToProps, mapDispatchToProps)(BaseProduct)


// WEBPACK FOOTER //
// ./src/components/pages/products/base/base.jsx